import {Magazine} from "./Magazine";

export class Edition {
    constructor(state) {

        if (state == null)
            state = {};

        const { id = 0, parentEditionAttachmentTypeId = null, magazineId = null, number = '', competenceDateFrom = null, competenceDateTo = null, description = '' } = state;

        this.id = id;
        this.parentEditionAttachmentTypeId = parentEditionAttachmentTypeId;
        this.magazineId = magazineId;
        this.number = number;
        this.competenceDateFrom = competenceDateFrom; //PublicationDate
        this.competenceDateTo = competenceDateTo;
        this.description = description; //etichetta
        this.magazine = new Magazine();

    }
}



// WEBPACK FOOTER //
// ./src/Models/Edition.js